import { Box, Text } from '@usealloy/component-library';
import styled from 'styled-components';


export const StyledOptionContainer = styled(Box) <{ disabled: boolean }>`
  &&& {
    justify-content: flex-start;
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  }
`;

export const StyledIconContainer = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 16;
  height: 16;
  flex-shrink: 0;
  border-radius: var(--cl-radius-0-5);
  display: flex;
  align-items: center;
`;


export const StyledOptionName = styled(Text)`
  &&& {
    flex-shrink: 0;
    margin-left: var(--cl-space-1);
    color: var(--cl-gray-1100);
  }
`;

export const StyledOptionTextDescription = styled(Text)`
  &&& {
    margin-left: var(--cl-space-2);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--cl-gray-700);
  }
`;
